// Values the backend stores in recording.audio.lastActionPerformed.
export const AUDIO_ACTIONS = {
    AUDIO: 'Audio',
    TRIM: 'Trim',
    MERGE: 'Merge',
    CONVERT: 'Convert',
    ADJUST: 'SpeedController',
    TRANSCRIBE: 'Transcribe',
};

export const ALL_ACTIONS_FILTER = 'all';

// Order, labels and match rules of the recording-list filter chips; a recording can match several.
export const AUDIO_ACTION_FILTERS = [
    { id: ALL_ACTIONS_FILTER, label: 'All', icon: 'lucide:layers', matches: () => true },
    { id: 'translate', label: 'Translate', icon: 'lucide:languages', matches: (recording) => recording?.translations?.length > 0 },
    { id: 'transcript', label: 'Transcript', icon: 'lucide:file-text', matches: (recording) => Boolean(recording?.transcribe?.isTranscribe || recording?.transcribe?.transcribeText) },
    { id: 'summary', label: 'Summary', icon: 'lucide:list', matches: (recording) => Boolean(recording?.transcribe?.summaryText?.trim()) },
    // Older records may only carry the single `note` field.
    { id: 'notes', label: 'Notes', icon: 'lucide:sticky-note', matches: (recording) => recording?.notes?.length > 0 || Boolean(recording?.note?._id) },
];

export const matchesActionFilter = (recording, filter) =>
    !filter || (AUDIO_ACTION_FILTERS.find((item) => item.id === filter)?.matches(recording) ?? true);
